import React from 'react';
import { FaBook, FaExternalLinkAlt, FaGamepad, FaYoutube } from 'react-icons/fa';

const Content: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-brand-primary mb-4">Ministry Resources</h1>
        <p className="text-xl text-brand-muted max-w-3xl mx-auto">
          Explore our collection of resources designed to help you grow in your faith and share the
          Gospel.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <div className="card hover:shadow-xl transition-shadow duration-300">
          <div className="p-6">
            <div className="icon-brand mb-4">
              <FaBook size={40} className="inline-block" />
            </div>
            <h2 className="text-2xl font-bold text-brand-primary mb-3">Tracts</h2>
            <p className="text-brand-muted mb-6">
              Share the Gospel with our collection of digital tracts. Each one is designed to
              clearly present the message of salvation.
            </p>
            <a
              href="https://ministriesforchrist.net/tracts/tract-001.html"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-brand-primary hover:text-brand-primarySoft font-medium"
            >
              View Tracts <FaExternalLinkAlt className="ml-2" size={14} />
            </a>
          </div>
        </div>

        <div className="card hover:shadow-xl transition-shadow duration-300">
          <div className="p-6">
            <div className="text-red-500 mb-4">
              <FaYoutube size={40} className="inline-block" />
            </div>
            <h2 className="text-2xl font-bold text-brand-primary mb-3">Videos</h2>
            <p className="text-brand-muted mb-6">
              Watch our collection of sermons, Bible studies, and worship music. New content coming
              soon!
            </p>
            <div className="text-brand-muted text-sm font-medium">Coming Soon</div>
          </div>
        </div>

        <div className="card hover:shadow-xl transition-shadow duration-300">
          <div className="p-6">
            <div className="text-green-600 mb-4">
              <FaGamepad size={40} className="inline-block" />
            </div>
            <h2 className="text-2xl font-bold text-brand-primary mb-3">Games</h2>
            <p className="text-brand-muted mb-6">
              Fun and engaging Bible-based games for all ages. Learn scripture and biblical
              principles through play.
            </p>
            <a
              href="https://ministriesforchrist.net/games/Ice_Breakers/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-brand-primary hover:text-brand-primarySoft font-medium"
            >
              Play Ice Breakers <FaExternalLinkAlt className="ml-2" size={14} />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 text-center">
        <h2 className="text-2xl font-bold text-brand-primary mb-4">More Resources Coming Soon</h2>
        <p className="text-brand-muted max-w-3xl mx-auto">
          We&apos;re constantly working on new content to help you grow in your faith. Check back
          often for updates!
        </p>
      </div>
    </div>
  );
};

export default Content;
